import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Row = ({ k, v }) => (
  <div className="grid grid-cols-[140px_1fr] gap-3 py-2 border-b border-[#14083E]/5 text-sm">
    <span className="text-slate-600">{k}</span>
    <span className="text-[#14083E] break-words">{v || "—"}</span>
  </div>
);

export default function DetailDialog({ item, onClose }) {
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="admin-detail-dialog">
        {item && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-2xl capitalize">{item.type} enrolment</DialogTitle>
            </DialogHeader>
            <div>
              <Row k="Name" v={item.name} />
              <Row k="Organisation" v={item.organization} />
              <Row k="Email" v={item.email} />
              <Row k="Phone" v={item.phone} />
              <Row k="City / State" v={item.city} />
              {Object.entries(item.details ?? {}).map(([k, v]) => <Row key={k} k={k.replace(/_/g, " ")} v={v} />)}
              <Row k="Message" v={item.message} />
              <Row k="Status" v={item.status} />
              <Row k="Email alert" v={item.email_notified ? "Sent" : "Not sent"} />
              <Row k="Submitted" v={new Date(item.created_at).toLocaleString()} />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
